import { useClientSearchQuery } from '../../lib/Queries';
import { useDebounce } from '@uidotdev/usehooks';
import Loading from '../Loading';
import ClientListItem from './ClientListItem.jsx';
import FormAnswer from '~/components/forms/submissions/FormAnswer';

const ResultExcerpt = ({ matches, search }) => {
    return (
        <div className="text-gray-500 text-sm">
            {matches.map((match, idx) => (
                <div key={idx} className="flex space-x-3">
                    <div className="font-semibold">{match.question.label}</div>
                    <FormAnswer
                        answer={match.answer}
                        question={match.question}
                    />
                </div>
            ))}
        </div>
    );
};

const ClientSearchResults = ({ search, setSelectedClient, className }) => {
    const debouncedSearch = useDebounce(search, 500);
    const { data, isLoading } = useClientSearchQuery(debouncedSearch);

    const results = data || [];

    if (!search) {
        return null;
    }

    return (
        <div className={className}>
            <div className="panel-label">Form Submission Results</div>
            <div className="panel pl-4">
                {isLoading && <Loading className="p-4" />}
                {!isLoading && results.length === 0 && (
                    <div className="text-gray-500 p-4">No results</div>
                )}
                {results.map((result, idx) => (
                    <ClientListItem
                        key={idx}
                        client={result.client}
                        onClick={() => setSelectedClient(result.client)}
                        isFirst={idx === 0}
                        footerContent={
                            <ResultExcerpt
                                search={search}
                                matches={result.matches}
                            />
                        }
                    />
                ))}
            </div>
        </div>
    );
};

export default ClientSearchResults;
